import { styled } from "baseui";
export const ClickCaptureContainer = styled("div", { position: "relative", width: "100%" });
export const ClickCaptureLayer = styled("div", { position: "absolute", top: 0, left: 0, right: 0, bottom: 0 });
